import { useMemo } from 'react'
import {
  DurationOverlay,
  PlayerLinkWrapper,
  PlayIconOverlay,
  VerticalPlayerItemEpisode,
} from './ItemComponents.style'
import { PlayIcon } from './icons'
import { he } from '../../../locales/he'
import { usePlayer } from './PlayerContext'

export const DurationComp = ({ duration }: { duration: number }) => {
  const durationStr = useMemo(() => {
    const mm = Math.floor(duration / 60)
    const ss = duration - mm * 60
    return `${(mm + '').padStart(2, '0')}:${(ss + '').padStart(2, '0')}`
  }, [duration])

  return (
    <DurationOverlay>
      <p>{durationStr}</p>
      <PlayIconOverlay>
        <PlayIcon />
      </PlayIconOverlay>
    </DurationOverlay>
  )
}

export const TitleEpisodeComp = ({ ep }: { ep?: number }) => {
  if (!ep) {
    return null
  }

  return (
    <VerticalPlayerItemEpisode>
      {he.episode + ' ' + ep}
    </VerticalPlayerItemEpisode>
  )
}

export const PlayerLink = ({
  link,
  link_title,
  handlePressPlayerLink,
}: {
  link?: string
  link_title?: string
  handlePressPlayerLink: () => void
}) => {
  const { isMiniSeries } = usePlayer()
  if (!link || isMiniSeries || !link_title) {
    return null
  }
  return (
    <PlayerLinkWrapper
      href={link}
      onClick={handlePressPlayerLink}
      target='_blank'
    >
      <p>{link_title}</p>
    </PlayerLinkWrapper>
  )
}
